import { HttpService } from '@/infra/http'
import type { TGetSimulacaoResponse } from '@/types/simulacao'

export class GetSimulacaoPorId extends HttpService {
  execute = async (simulacaoId: string) => {
    return this.http.get<TGetSimulacaoResponse>(`/api/v2/Simulacao/${simulacaoId}`)
  }
}
